export const ADMIN_EMAIL = "abbasali7342@gmail.com";  // your admin email
export const ADMIN_PASSWORD = "sahil7342";        // your password
